@if (shouldShowErrors() && errorMessage()) {
  <neo-error>
    {{ errorMessage() }}
  </neo-error>
}
